import { defineComponent, inject, ref } from 'vue';
import SButton from '@/components/stemdo-components/s-button/SButton.vue';
import TeamRequestService from '@/sections/admin/entities/team-request/team-request.service';
import { TeamRequest } from '@/shared/model/team-request.model';
import { RequestStatus } from '@/shared/model/enumerations/request-status.model';
import { useStore } from '@/plugins/vuex';

export default defineComponent({
  props: {
    teamRequest: {
      type: Object as () => TeamRequest,
      required: true
    },
    onOpenModal: {
      type: Function,
      required: true
    }
  },
  components: {
    SButton
  },
  setup(props) {
    const teamRequestService: TeamRequestService = inject('teamRequestService');
    const store = useStore();

    const sendNewProposal = () => {
      try {
        const rates = store?.state?.checkoutStore?.stemdoerRates;
        if (Array.isArray(props.teamRequest.stemdoerRates) && rates && Array.isArray(rates)) {
          props.teamRequest.stemdoerRates.forEach(sr => {
            const stemdoerId = sr.stemdoer?.id;
            if (stemdoerId) {
              const found = rates.find((r: any) => r.stemdoerId === stemdoerId);
              if (found && typeof found.rate === 'number') {
                sr.rate = found.rate;
              }
            }
          });
        }
      } catch (e) {
        console.error(e);
      }
      if (props.teamRequest.status === RequestStatus.VALIDATED) {
        teamRequestService
          .partialUpdate(props.teamRequest)
          .then(res => {
            props.onOpenModal({ id: res.id });
            store.dispatch('checkoutStore/clearCheckout');
            store.commit('cartStore/clearCart');
          })
          .catch(error => {
            console.error(error);
          });
      } else if (props.teamRequest.status === RequestStatus.PENDING) {
        teamRequestService
          .validateAndPartialUpdate(props.teamRequest)
          .then(res => {
            props.onOpenModal({ id: res.id });
            store.dispatch('checkoutStore/clearCheckout');
            store.commit('cartStore/clearCart');
          })
          .catch(error => {
            console.error(error);
          });
      }
      props.onOpenModal();
    };

    return {
      sendNewProposal
    };
  }
});
